<template>
  <div class="pmAuth">
    <div class="pmAuthBg"></div>
    <div class="pmAuthInner">
      <!-- 品牌 -->
      <div class="pmBrand">
        <div class="pmLogoWrap">
          <img class="pmLogo" :src="$store.state.appInfo.site_logo || '/static/image/app-logo.png'" alt="" />
        </div>
        <div class="pmSiteName">{{ $store.state.appInfo.title }}</div>
        <div class="pmSlogan"><i class="pmSlgLine"></i><span>尊享 · 高级会员体验</span><i class="pmSlgLine"></i></div>
      </div>

      <!-- 卡片 -->
      <div class="pmCard">
        <div class="pmTabs">
          <div class="pmTab" :class="{ on: infoType == 0 }" @click="changInfoType(0)">登录</div>
          <div class="pmTab" :class="{ on: infoType == 1 }" @click="changInfoType(1)">注册</div>
          <div class="pmTabInk" :class="{ right: infoType == 1 }"></div>
        </div>

        <!-- 登录 -->
        <div v-if="infoType == 0" class="pmForm">
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            <input maxlength="32" v-model="loginInfo.name" placeholder="请输入用户名" type="text" autocomplete="off" />
          </div>
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
            <input placeholder="请输入密码" v-model="loginInfo.password" maxlength="32" type="password" autocomplete="off" />
          </div>
          <div class="pmField pmFieldCode">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            <input maxlength="6" v-model="loginInfo.code" placeholder="验证码" type="text" autocomplete="off" />
            <img class="pmCode" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </div>

          <button class="pmBtn" @click="login" type="button">登 录</button>
          <div class="pmLinks">
            <a @click="$parent.goNav('/')">先去逛逛</a>
            <a @click="$parent.openKefu">在线客服</a>
          </div>
        </div>

        <!-- 注册 -->
        <div v-if="infoType == 1" class="pmForm">
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            <input v-model="registerInfo.name" placeholder="用户名（6~16位字母或数字）" maxlength="32" type="text" autocomplete="off" />
          </div>
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
            <input placeholder="登录密码（最少6位）" v-model="registerInfo.password" maxlength="32" type="password" autocomplete="off" />
          </div>
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
            <input placeholder="确认登录密码" v-model="registerInfo.confirmPass" maxlength="32" type="password" autocomplete="off" />
          </div>
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
            <input v-model="registerInfo.realname" placeholder="真实姓名" maxlength="32" type="text" autocomplete="off" />
          </div>
          <div class="pmField">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line></svg>
            <input placeholder="支付密码（最少6位）" v-model="registerInfo.paypassword" maxlength="32" type="password" autocomplete="off" />
          </div>
          <div class="pmField pmFieldCode">
            <svg class="pmIco" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            <input v-model="registerInfo.code" maxlength="4" placeholder="验证码" type="text" autocomplete="off" />
            <img class="pmCode" :src="`/static/image/yzm/${imgLis[index]}.png`" @click="changIndex" alt="" />
          </div>

          <button class="pmBtn" @click="register" type="button">注 册</button>
          <div class="pmLinks pmLinksCenter">
            <a @click="$parent.openKefu">遇到问题？联系在线客服</a>
          </div>
        </div>
      </div>

      <div class="pmFootTip">继续即代表同意相关条款与隐私政策</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.$parent.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      if (!info.confirmPass || info.confirmPass != info.password) {
        that.$parent.showTost(0, '两次密码不一致！');
        return;
      }
      if (!info.realname || info.realname.length < 2) {
        that.$parent.showTost(0, '请输入您的真实姓名!');
        return;
      }

      if (!info.paypassword || info.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        return;
      }
      let code = that.registerInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.registerInfo.code = null;
        that.changIndex();
        return;
      }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info)
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    login() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;
      if (!code) {
        that.$parent.showTost(0, '请输入验证码！');

        return;
      }
      if (code.toUpperCase() != that.imgLis[that.index]) {
        that.$parent.showTost(0, '验证码错误！');
        that.loginInfo.code = null;
        that.changIndex();
        return;
      }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.pmAuth {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  overflow-y: auto;
  background: #f7f8fa;
}
.pmAuthBg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 340px;
  background: linear-gradient(165deg, #2c0715 0%, #4a0e22 52%, #641530 100%);
  border-bottom-left-radius: 44px;
  border-bottom-right-radius: 44px;
  overflow: hidden;
}
.pmAuthBg::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 20px;
  width: 300px;
  height: 300px;
  transform: translateX(-50%);
  border-radius: 50%;
  background: radial-gradient(circle at 50% 40%, rgba(230, 200, 119, 0.32), rgba(230, 200, 119, 0) 62%);
}
.pmAuthBg::after {
  content: '';
  position: absolute;
  right: -50px;
  top: -50px;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0) 70%);
}
.pmAuthInner {
  position: relative;
  z-index: 2;
  padding: 0 22px 30px;
}
.pmBrand {
  text-align: center;
  padding: 42px 0 24px;
  color: #fff;
}
.pmLogoWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 84px;
  height: 84px;
  border-radius: 22px;
  background: linear-gradient(160deg, rgba(255, 255, 255, 0.22), rgba(255, 255, 255, 0.06));
  border: 1.5px solid rgba(230, 200, 119, 0.65);
  box-shadow: 0 10px 26px rgba(8, 20, 55, 0.45), 0 0 22px rgba(230, 200, 119, 0.28);
  backdrop-filter: blur(2px);
}
.pmLogo {
  width: 70px;
  height: 70px;
  border-radius: 16px;
  object-fit: cover;
  display: block;
}
.pmSiteName {
  margin-top: 14px;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 8px rgba(8, 20, 55, 0.4);
}
.pmSlogan {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.pmSlogan span {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  letter-spacing: 3px;
  padding: 0 10px;
}
.pmSlgLine {
  display: inline-block;
  width: 26px;
  height: 1px;
  background: linear-gradient(90deg, rgba(230, 200, 119, 0), rgba(230, 200, 119, 0.85));
}
.pmSlgLine:last-child {
  background: linear-gradient(90deg, rgba(230, 200, 119, 0.85), rgba(230, 200, 119, 0));
}

.pmCard {
  background: #fff;
  border-radius: 20px;
  padding: 8px 20px 22px;
  box-shadow: 0 12px 30px rgba(16, 24, 40, 0.12);
}
.pmTabs {
  position: relative;
  display: flex;
  height: 52px;
  margin-bottom: 14px;
  border-bottom: 1px solid #eef0f3;
}
.pmTab {
  flex: 1;
  text-align: center;
  line-height: 52px;
  font-size: 17px;
  color: #94a3b8;
  font-weight: 600;
  transition: color 0.2s;
}
.pmTab.on {
  color: #0f172a;
  font-weight: 800;
}
.pmTabInk {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 50%;
  height: 3px;
  border-radius: 3px;
  background: linear-gradient(135deg, #e6c877, #c69a3f);
  transition: transform 0.25s ease;
}
.pmTabInk.right {
  transform: translateX(100%);
}

.pmField {
  display: flex;
  align-items: center;
  height: 50px;
  margin-top: 14px;
  padding: 0 14px;
  border-radius: 12px;
  background: #f7f8fa;
  border: 1px solid #eef0f3;
  transition: border-color 0.15s, background 0.15s;
}
.pmField:focus-within {
  border-color: #c69a3f;
  background: #fff;
}
.pmIco {
  width: 19px;
  height: 19px;
  color: #94a3b8;
  flex-shrink: 0;
}
.pmField:focus-within .pmIco {
  color: #c69a3f;
}
.pmField input {
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  margin-left: 10px;
  font-size: 15px;
  color: #0f172a;
}
.pmField input::placeholder {
  color: #b0b8c4;
}
.pmFieldCode input {
  min-width: 0;
}
.pmCode {
  height: 34px;
  border-radius: 6px;
  margin-left: 8px;
  cursor: pointer;
  flex-shrink: 0;
}

.pmBtn {
  width: 100%;
  height: 50px;
  margin-top: 22px;
  border: none;
  border-radius: 25px;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 4px;
  color: #fff;
  background: linear-gradient(135deg, #e6c877, #c69a3f);
  box-shadow: 0 8px 18px rgba(198, 154, 63, 0.35);
  text-shadow: 0 1px 1px rgba(120, 80, 0, 0.3);
  cursor: pointer;
}
.pmBtn:active {
  transform: translateY(1px);
  box-shadow: 0 4px 10px rgba(198, 154, 63, 0.3);
}
.pmLinks {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  font-size: 13px;
}
.pmLinksCenter {
  justify-content: center;
}
.pmLinks a {
  color: #8a1a34;
  cursor: pointer;
}
.pmFootTip {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  color: #94a3b8;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue